import React from 'react';
import { ThemeColor, useThemeColor } from '../Theme';
import { StyledTooltipIcon } from './Tooltip.styled';
export function DefaultTooltipIcon() {
  return /*#__PURE__*/React.createElement(StyledTooltipIcon, {
    size: 16,
    color: useThemeColor(ThemeColor.secondaryText)
  });
}